<div class="body">
    <app-menu (comunicarSeccion)="getSeccion($event)"></app-menu>
    <app-listado-menu [seccion]="seccion"></app-listado-menu>
    <app-footer class="footer"></app-footer>
</div>
